import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import SettingField from 'components/Fields/ReduxForm/SettingField';

import TooltipCommerceStore from 'components/TooltipCommerce';
import styles from './SalesTypeItemVariantsFields.css';

class SalesTypeItemVariantsFields extends React.Component {
  render() {
    const {
      member,
      fields,
      index,
      salesTypeIndex,
      disabled,
      ecommerceAttributes,
    } = this.props;
    const isHide =
      fields.length === 1 &&
      fields.get(index) &&
      (fields.get(index).name === undefined || fields.get(index).name === '')
        ? 'hide'
        : 'show';
    const isFirstColumn = index === 0;
    return (
      <div className="mk-grouped-input">
        {isHide !== 'hide' && (
          <div className={`form-group col-md-4`}>
            {ecommerceAttributes && isFirstColumn && (
              <div className={`panel-heading ${styles['panel-head']}`}>
                <label>Variant Name</label>
              </div>
            )}
            <Field
              name={`${member}.name`}
              component={SettingField}
              className="form-control"
              placeholder="Name"
              readOnly
            />
          </div>
        )}
        <div
          className={`form-group ${
            isHide === 'hide' ? 'col-md-6' : 'col-md-4 no-padding'
          }`}
        >
          {ecommerceAttributes && isFirstColumn && (
            <div className={`panel-heading ${styles['panel-head']}`}>
              <TooltipCommerceStore
                placement="top"
                delay={200}
                name={'basePrice'}
              >
                <label>
                  Base Price
                  <span
                    className={`glyphicon glyphicon-info-sign ${
                      styles['icon-container']
                    }`}
                  />
                </label>
              </TooltipCommerceStore>
            </div>
          )}
          <Field
            name={`${member}.sales_type_items[${salesTypeIndex}].sales_type_price`}
            parse={value =>
              value === '' ? '' : value.length > 11 ? value : Number(value)
            }
            component={SettingField}
            placeholder="Price"
            readOnly={disabled}
            inputClassName={`text-right ${ecommerceAttributes &&
              styles['input-ecommerce']}`}
            positiveNumberOnly
          />
        </div>
        <div
          className={`form-group ${
            isHide === 'hide' ? 'col-md-6' : 'col-md-4'
          }`}
        >
          {ecommerceAttributes && isFirstColumn && (
            <div className={`panel-heading ${styles['panel-head']}`}>
              <TooltipCommerceStore
                placement="top"
                onMouseEnter={() => {}}
                delay={200}
                name={'sku'}
              >
                <label>
                  SKU
                  <span
                    className={`glyphicon glyphicon-info-sign ${
                      styles['icon-container']
                    }`}
                  />
                </label>
              </TooltipCommerceStore>
            </div>
          )}
          <Field
            name={`${member}.sku`}
            component={SettingField}
            placeholder="SKU"
            inputClassName={`text-right ${ecommerceAttributes &&
              styles['input-ecommerce']}`}
            positiveNumberOnly
            readOnly
          />
        </div>
      </div>
    );
  }
}

SalesTypeItemVariantsFields.propTypes = {
  member: PropTypes.object,
  fields: PropTypes.object,
  index: PropTypes.integer,
  salesTypeIndex: PropTypes.integer,
};

export default SalesTypeItemVariantsFields;
